<template>
    <ul class="nav nav-tabs conversions-tabs">
        <li class="nav-item">
            <router-link :to="'/statistic/refunds/return_by_month'" class="nav-link" exact><i class="fa fa-undo"></i> {{ $t('pages.ref_return_by_month') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/refunds/cancel_by_month'" class="nav-link" exact><i class="fa fa-ban"></i> {{ $t('pages.ref_cancel_by_month') }}</router-link>
        </li>
      <li class="nav-item">
        <router-link :to="'/statistic/refunds/cancel_operators'" class="nav-link" exact><i class="fa fa-ban"></i> {{ $t('pages.ref_cancel_operators') }}</router-link>
      </li>
    </ul>
</template>

<script>
  export default {
    name: 'RefundsTabs'
  }
</script>



// WEBPACK FOOTER //
// RefundsTabs.vue?2a4e7791